// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fampe-input-range {
  position: relative;
  width: 100%;
  margin: 15px 0;
  max-width: 815px;
  border-radius: 12px;
  padding: 1px;
  background: var(--sebrae-white);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.fampe-input-range.wbs {
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
}
.fampe-input-range .input-range {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  border-radius: 12px;
  background: var(--sebrae-white);
  color: var(--sebrae-dark-gray2);
}
.fampe-input-range .input-range.wbs {
  padding: 16px;
}
.fampe-input-range .input-range label {
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  margin-bottom: 15px;
}
.fampe-input-range .input-range input {
  width: 100%;
  appearance: none;
  outline: none;
  margin: 0;
  outline: 0;
  height: 3px;
  border-radius: 10px;
  background: var(--sebrae-light-gray4);
  outline: none;
  cursor: pointer;
}
.fampe-input-range .input-range input::-webkit-slider-runnable-track {
  display: flex;
  align-items: center;
  position: relative;
  height: 3px;
  border-radius: 10px;
  background: var(--sebrae-light-gray4);
}
.fampe-input-range .input-range input::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  z-index: 2;
  background-color: var(--sebrae-blue);
  transform: translateY(-6px);
  cursor: inherit;
}
.fampe-input-range .input-range input::-moz-range-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--sebrae-blue);
  cursor: inherit;
  border: none;
}
.fampe-input-range .input-range__wrapper-input {
  position: relative;
  width: 100%;
  padding: 25px 0;
  display: flex;
  align-items: center;
}
.fampe-input-range .input-range__wrapper-input small {
  font-size: 11px;
  font-style: italic;
  font-weight: 400;
  line-height: 1;
  color: var(--sebrae-dark-gray2);
  position: absolute;
  bottom: 0;
}
.fampe-input-range .input-range__wrapper-input small:first-of-type {
  left: 0;
}
.fampe-input-range .input-range__wrapper-input small:last-of-type {
  right: 0;
}
.fampe-input-range .input-range__wrapper-input .range-marker {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 4px;
  height: 14px;
  border-radius: 2px;
  pointer-events: none;
  background-color: green;
  transform: translate(-50%, -50%);
}
.fampe-input-range .input-range__wrapper-input .range-marker span {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: green;
  white-space: nowrap;
  text-align: center;
  line-height: 1.2;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 700;
}
.fampe-input-range .input-range__wrapper-input .label-value {
  position: absolute;
  left: 0;
  z-index: 1;
  top: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  display: flex;
  align-items: center;
}
.fampe-input-range .input-range__wrapper-input .wrapper-line-input {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}
.fampe-input-range .input-range__wrapper-input .wrapper-line-input .percent-bar {
  position: absolute;
  left: 0;
  height: 4px;
  border-radius: 4px;
  width: 0;
  z-index: 1;
  background-color: var(--sebrae-blue-6);
  transition: background-color 0.3s ease-in-out;
}
.fampe-input-range .input-range__wrapper-input .wrapper-line-input .percent-bar.green {
  background-color: var(--sebrae-light-green);
}
.fampe-input-range .input-range__wrapper-input .wrapper-line-input .percent-bar.yellow {
  background-color: var(--sebrae-yellow);
}
.fampe-input-range .input-range__wrapper-input .wrapper-line-input .percent-bar.blue {
  background-color: var(--sebrae-blue-6);
}
.fampe-input-range .input-range__wrapper-input .wrapper-line-input .percent-bar.red {
  background-color: var(--sebrae-red);
}
.fampe-input-range.has-value .input-range {
  color: var(--sebrae-black);
}
.fampe-input-range.new-style {
  border-radius: 4px;
}
.fampe-input-range.new-style .input-range {
  color: var(--sebrae-gray);
}
.fampe-input-range.new-style .input-range label {
  line-height: 1.3;
}
.fampe-input-range.new-style .input-range input {
  height: 4px;
}
.fampe-input-range.new-style .input-range__wrapper-input .label-value {
  color: var(--sebrae-dark-gray2);
}
.fampe-input-range.new-style .input-range__wrapper-input .range-marker {
  background-color: var(--sebrae-light-green);
}
.fampe-input-range.new-style .input-range__wrapper-input .range-marker span {
  color: var(--sebrae-light-green);
  font-size: 11px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/fampe-input-range/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;EACA,kDAAA;AACF;AACE;EACE,6CAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EAEA,+BAAA;EACA,+BAAA;AADJ;AAGI;EACE,aAAA;AADN;AAII;EAEI,eAAA;EACA,gBAAA;EAEF,iBAAA;EACA,mBAAA;AAJN;AAMI;EACE,WAAA;EAEA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;EACA,eAAA;AAJN;AAMM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,qCAAA;AAJR;AAMM;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,2BAAA;EACA,eAAA;AAJR;AAMM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,YAAA;AAJR;AAOI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AALN;AAOM;EAEI,eAAA;EACA,kBAAA;EACA,gBAAA;EAEF,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,SAAA;AAPR;AASQ;EACE,OAAA;AAPV;AASQ;EACE,QAAA;AAPV;AAUM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gCAAA;AARR;AAUQ;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AARV;AAWM;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,MAAA;EAEE,eAAA;EACA,gBAAA;EAEF,cAAA;EACA,aAAA;EACA,mBAAA;AAXR;AAaM;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAXR;AAaQ;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sCAAA;EACA,6CAAA;AAXV;AAaU;EACE,2CAAA;AAXZ;AAaU;EACE,sCAAA;AAXZ;AAaU;EACE,sCAAA;AAXZ;AAaU;EACE,mCAAA;AAXZ;AAkBI;EACE,0BAAA;AAhBN;AAoBE;EACE,kBAAA;AAlBJ;AAoBI;EACE,yBAAA;AAlBN;AAoBM;EACE,gBAAA;AAlBR;AAoBM;EACE,WAAA;AAlBR;AAqBQ;EACE,+BAAA;AAnBV;AAqBQ;EACE,2CAAA;AAnBV;AAqBU;EACE,gCAAA;EAEE,eAAA;EACA,gBAAA;AApBd","sourcesContent":[".fampe-input-range {\n  position: relative;\n  width: 100%;\n  margin: 15px 0;\n  max-width: 815px;\n  border-radius: 12px;\n  padding: 1px;\n  background: var(--sebrae-white);\n  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  &.wbs {\n    box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n  }\n\n  .input-range {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: 100%;\n    border-radius: 12px;\n\n    background: var(--sebrae-white);\n    color: var(--sebrae-dark-gray2);\n\n    &.wbs {\n      padding: 16px;\n    }\n\n    label {\n      font: {\n        size: 16px;\n        weight: 400;\n      }\n      line-height: 23px;\n      margin-bottom: 15px;\n    }\n    input {\n      width: 100%;\n      -webkit-appearance: none;\n      appearance: none;\n      outline: none;\n      margin: 0;\n      outline: 0;\n      height: 3px;\n      border-radius: 10px;\n      background: var(--sebrae-light-gray4);\n      outline: none;\n      cursor: pointer;\n\n      &::-webkit-slider-runnable-track {\n        display: flex;\n        align-items: center;\n        position: relative;\n        height: 3px;\n        border-radius: 10px;\n        background: var(--sebrae-light-gray4);\n      }\n      &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        appearance: none;\n        width: 16px;\n        height: 16px;\n        border-radius: 50%;\n        border: none;\n        z-index: 2;\n        background-color: var(--sebrae-blue);\n        transform: translateY(-6px);\n        cursor: inherit;\n      }\n      &::-moz-range-thumb {\n        appearance: none;\n        width: 16px;\n        height: 16px;\n        border-radius: 50%;\n        background-color: var(--sebrae-blue);\n        cursor: inherit;\n        border: none;\n      }\n    }\n    &__wrapper-input {\n      position: relative;\n      width: 100%;\n      padding: 25px 0;\n      display: flex;\n      align-items: center;\n\n      small {\n        font: {\n          size: 11px;\n          style: italic;\n          weight: 400;\n        }\n        line-height: 1;\n        color: var(--sebrae-dark-gray2);\n        position: absolute;\n        bottom: 0;\n\n        &:first-of-type {\n          left: 0;\n        }\n        &:last-of-type {\n          right: 0;\n        }\n      }\n      .range-marker {\n        position: absolute;\n        top: 50%;\n        z-index: 2;\n        width: 4px;\n        height: 14px;\n        border-radius: 2px;\n        pointer-events: none;\n        background-color: green;\n        transform: translate(-50%, -50%);\n\n        span {\n          position: absolute;\n          top: 100%;\n          left: 50%;\n          transform: translateX(-50%);\n          color: green;\n          white-space: nowrap;\n          text-align: center;\n          line-height: 1.2;\n          margin-top: 4px;\n          font-size: 12px;\n          font-weight: 700;\n        }\n      }\n      .label-value {\n        position: absolute;\n        left: 0;\n        z-index: 1;\n        top: 0;\n        font: {\n          size: 13px;\n          weight: 400;\n        }\n        line-height: 1;\n        display: flex;\n        align-items: center;\n      }\n      .wrapper-line-input {\n        position: relative;\n        width: 100%;\n        display: flex;\n        align-items: center;\n\n        .percent-bar {\n          position: absolute;\n          left: 0;\n          height: 4px;\n          border-radius: 4px;\n          width: 0;\n          z-index: 1;\n          background-color: var(--sebrae-blue-6);\n          transition: background-color 0.3s ease-in-out;\n\n          &.green {\n            background-color: var(--sebrae-light-green);\n          }\n          &.yellow {\n            background-color: var(--sebrae-yellow);\n          }\n          &.blue {\n            background-color: var(--sebrae-blue-6);\n          }\n          &.red {\n            background-color: var(--sebrae-red);\n          }\n        }\n      }\n    }\n  }\n  &.has-value {\n    .input-range {\n      color: var(--sebrae-black);\n    }\n  }\n\n  &.new-style {\n    border-radius: 4px;\n\n    .input-range {\n      color: var(--sebrae-gray);\n\n      label {\n        line-height: 1.3;\n      }\n      input {\n        height: 4px;\n      }\n      &__wrapper-input {\n        .label-value {\n          color: var(--sebrae-dark-gray2);\n        }\n        .range-marker {\n          background-color: var(--sebrae-light-green);\n\n          span {\n            color: var(--sebrae-light-green);\n            font: {\n              size: 11px;\n              weight: 400;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
